import http from "../http-common"; 

class FieldService {
  getAllFields(searchDTO) {
    console.log(searchDTO)
    return this.getRequest(`/field/fields`, searchDTO);
  }

  get(fieldId) {
    return this.getRequest(`/field/${fieldId}`, null);
  }

  findByField(matchData) {
    return this.getRequest(`/field?field=${matchData}`, null);
  }

  addField(data) {
    return http.post("/field/addField", data);
  }

  update(data) {
  	return http.post("/field/updateField", data);
  }
  
  uploadImage(data,fieldId) {
  	return http.postForm("/field/uploadImage/"+fieldId, data);
  }




	postRequest(url, data) {
        const token = localStorage.getItem('authToken');
        if (token) {
            return http.post(url, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }
      };

	getRequest(url, params) {
        const token = localStorage.getItem('authToken');
        if (token) {
            return http.get(url, {
            	params: params,
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }
    };

}

export default new FieldService();
